import Vue from 'vue';
import { distributionType } from './constants/distribution';

export const PRODUCT_CATEGORY = {
  CONFECTION_SERVICE: 'KONF',
  CONFECTION_SERVICE_ONE: 'KONF_ONE',
  CONFECTION_SERVICE_MANY: 'KONF_MANY',
  CONFECTION_SERVICE_PRD: 'KONF_PRD',
  CONFECTION_MARKETING: 'MKT_ISS',
};

export const VOUCHER_CATEGORY = {
  MONO: 'EPV_ISS',
  OPEN: 'OEPV_ISS',
};

export const NDE_CONFECTION = {
  PROMO_PACKET: 'ND_SMART',
  ETUI: 'ND_CASE',
  ETUI_PUT_IN: 'ND_CASE_IN',
  ETUI_PERSONALISATION: 'ND_CASE_PR',
  ENVELOPE_PERSONALISATION: 'ND_ENV_PR',
  ENVELOPE_LAYOUT: 'ND_ENV_PL',
  GREETING_CARD: 'ND_FLY_PR',
  LEAFLETS: 'ND_FLY_IN',
  SUBPACKAGES: 'ND_MULTI',
  GRANTING_REASON: 'ND_DESC_TX',
  // TODO
  LOGO: 'ND_LOGO',
};

export const COUPON_CATEGORY = 'V_ISS';
export const VIRTUAL_CARD_CATEGORY = 'ECV_ISS';
export const PHYSICAL_CARD_CATEGORY = 'EC_ISS';
export const NDE_VIRTUAL_CATEGORY = 'ND_ECV_ISS';
export const NDE_PHYSICAL_CATEGORY = 'ND_EC_ISS';

export const DELIVERY_POINTS_CATEGORY = 'AD';

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsPromoPacket = (productsFromStore: any) => (
  productsFromStore.product_category === NDE_CONFECTION.PROMO_PACKET
);
/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsDeliveryPoint = (productsFromStore: any) => (
  productsFromStore.product_category === DELIVERY_POINTS_CATEGORY
);
/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsNDE = (productsFromStore: any) => (
  [NDE_VIRTUAL_CATEGORY, NDE_PHYSICAL_CATEGORY].includes(productsFromStore.product_category)
);
/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsPhysicalNDE = (productsFromStore: any) => (
  productsFromStore.product_category === NDE_PHYSICAL_CATEGORY
);
/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsVirtualNDE = (productsFromStore: any) => (
  productsFromStore.product_category === NDE_VIRTUAL_CATEGORY
);
/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsNDEOwnDistribution = (productsFromStore: any) => {
  const isDistributionOwn = Vue.prototype.$store.getters['additionalInfo/distribution'] === distributionType.SODEXO;
  return productsFromStore.product_category === NDE_VIRTUAL_CATEGORY && isDistributionOwn;
};
/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsNDEExternalDistribution = (productsFromStore: any) => {
  const isDistributionExternal = Vue.prototype.$store.getters['additionalInfo/distribution'] === distributionType.CLIENT;
  return productsFromStore.product_category === NDE_VIRTUAL_CATEGORY && isDistributionExternal;
};
/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsEVoucher = (productsFromStore: any) => (
  [
    VOUCHER_CATEGORY.MONO,
    VOUCHER_CATEGORY.OPEN,
  ].includes(productsFromStore.product_category)
);
/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsOpenEVoucher = (productsFromStore: any) => (
  productsFromStore.product_category === VOUCHER_CATEGORY.OPEN
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsMonoEVoucher = (productsFromStore: any) => (
  productsFromStore.product_category === VOUCHER_CATEGORY.MONO
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsCoupon = (productsFromStore: any) => (
  productsFromStore.product_category === COUPON_CATEGORY
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsPhysicalCard = (productsFromStore: any) => (
  [PHYSICAL_CARD_CATEGORY, NDE_PHYSICAL_CATEGORY].includes(productsFromStore.product_category)
);
/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsVirtualCard = (productsFromStore: any) => (
  [VIRTUAL_CARD_CATEGORY, NDE_VIRTUAL_CATEGORY].includes(productsFromStore.product_category)
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsGift = (productsFromStore: any) => (
  ['1', '25', '35', 'GGDO', 'GGPO', 'GBDO', 'GBPR', 'GBPO', 'GBDR'].includes(productsFromStore.product_type)
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsNDEConfection = (productsFromStore: any) => (
  [
    NDE_CONFECTION.PROMO_PACKET,
    NDE_CONFECTION.ETUI,
    NDE_CONFECTION.ETUI_PUT_IN,
    NDE_CONFECTION.ETUI_PERSONALISATION,
    NDE_CONFECTION.ENVELOPE_PERSONALISATION,
    NDE_CONFECTION.ENVELOPE_LAYOUT,
    NDE_CONFECTION.GREETING_CARD,
    NDE_CONFECTION.LEAFLETS,
    NDE_CONFECTION.SUBPACKAGES,
    NDE_CONFECTION.GRANTING_REASON,
    NDE_CONFECTION.LOGO,
  ].includes(productsFromStore.product_category)
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsNDEPackagingConfection = (productsFromStore: any) => (
  [
    NDE_CONFECTION.ETUI,
    NDE_CONFECTION.ETUI_PUT_IN,
    NDE_CONFECTION.GREETING_CARD,
    NDE_CONFECTION.LEAFLETS,
  ].includes(productsFromStore.product_category)
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsNDEPersonalizedConfection = (productsFromStore: any) => (
  [
    NDE_CONFECTION.ETUI_PERSONALISATION,
    NDE_CONFECTION.ENVELOPE_PERSONALISATION,
  ].includes(productsFromStore.product_category)
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsNDELayoutConfection = (productsFromStore: any) => (
  [
    NDE_CONFECTION.SUBPACKAGES,
    NDE_CONFECTION.ENVELOPE_LAYOUT,
  ].includes(productsFromStore.product_category)
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsNDEAppConfection = (productsFromStore: any) => (
  [
    NDE_CONFECTION.GRANTING_REASON,
    NDE_CONFECTION.LOGO,
  ].includes(productsFromStore.product_category)
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsConfection = (productsFromStore: any) => (
  [
    PRODUCT_CATEGORY.CONFECTION_MARKETING,
    PRODUCT_CATEGORY.CONFECTION_SERVICE,
    PRODUCT_CATEGORY.CONFECTION_SERVICE_MANY,
    PRODUCT_CATEGORY.CONFECTION_SERVICE_ONE,
    PRODUCT_CATEGORY.CONFECTION_SERVICE_PRD,
    NDE_CONFECTION.PROMO_PACKET,
    NDE_CONFECTION.ETUI,
    NDE_CONFECTION.ETUI_PUT_IN,
    NDE_CONFECTION.ETUI_PERSONALISATION,
    NDE_CONFECTION.ENVELOPE_PERSONALISATION,
    NDE_CONFECTION.ENVELOPE_LAYOUT,
    NDE_CONFECTION.GREETING_CARD,
    NDE_CONFECTION.LEAFLETS,
    NDE_CONFECTION.SUBPACKAGES,
    NDE_CONFECTION.GRANTING_REASON,
    NDE_CONFECTION.LOGO,
  ].includes(productsFromStore.product_category)
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsConfectionService = (productsFromStore: any) => (
  [
    PRODUCT_CATEGORY.CONFECTION_SERVICE,
    PRODUCT_CATEGORY.CONFECTION_SERVICE_MANY,
    PRODUCT_CATEGORY.CONFECTION_SERVICE_ONE,
    PRODUCT_CATEGORY.CONFECTION_SERVICE_PRD,
  ].includes(productsFromStore.product_category)
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsMarketingProduct = (productsFromStore: any) => (
  PRODUCT_CATEGORY.CONFECTION_MARKETING === productsFromStore.product_category
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsConfectionOne = (productsFromStore: any) => (
  PRODUCT_CATEGORY.CONFECTION_SERVICE_ONE === productsFromStore.product_category
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductIsConfectionMany = (productsFromStore: any) => (
  PRODUCT_CATEGORY.CONFECTION_SERVICE_MANY === productsFromStore.product_category
);

/**
 * @param productsFromStore
 * @return boolean
 */
export const checkProductsIsConfectionServiceBasedOnQuantity = (productsFromStore: any) => (
  checkProductIsConfectionOne(productsFromStore) || checkProductIsConfectionMany(productsFromStore)
);
